<script lang="ts">
    import type { Snippet } from "svelte";
    import { fly } from "svelte/transition";
    import ButtonClose from "../Input/ButtonClose.svelte";
    import { focusTrap } from "../../Utils/svelte-focus-trap";
    import { modals } from "@wa-modals";

    interface Props {
        isOpen?: boolean;
        withAction?: boolean;
        title?: Snippet;
        content?: Snippet;
        action?: Snippet;
    }

    let { isOpen = false, withAction = true, title, content, action }: Props = $props();

    const titleId = "popup-title-" + Math.random().toString(36).slice(2);

    function onKeyDown(event: KeyboardEvent) {
        if (isOpen && event.key === "Escape") {
            event.preventDefault();
            modals.close();
        }
    }
</script>

<svelte:window onkeydown={onKeyDown} />

{#if isOpen}
    <div class="absolute flex items-center justify-center w-full h-full">
        <div
            use:focusTrap
            role="dialog"
            aria-modal="true"
            aria-labelledby={titleId}
            class="bg-mlight/80 shadow-light rounded-md2 backdrop-blur-md z-2001 w-[90%] m-auto left-0 right-0 sm:max-w-[668px] max-h-full overflow-y-auto pointer-events-auto"
            transition:fly={{ y: -1000, delay: 0, duration: 300 }}
        >
            <div class="p-6 flex flex-col justify-center items-center" class:pb-2={withAction}>
                <div class="flex-row flex items-start w-full justify-between gap-4 mb-2">
                    <div id={titleId} class="p-2 self-center flex-1 text-center">
                        {@render title?.()}
                    </div>
                    <div>
                        <ButtonClose
                            dataTestId="closeModal"
                            onclick={(event) => {
                                event.preventDefault();
                                event.stopPropagation();
                                modals.close();
                            }}
                        />
                    </div>
                </div>
                {@render content?.()}
            </div>
            {#if withAction}
                <div class="flex flex-row justify-evenly items-center w-full p-4 gap-3">
                    {@render action?.()}
                </div>
            {/if}
        </div>
    </div>
{/if}
